"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createI18nApiFactory = void 0;
/* eslint-disable @typescript-eslint/no-empty-function */
const LocalizedString_1 = require("./LocalizedString");
const useGuaranteedMemo_1 = require("powerhooks/useGuaranteedMemo");
const symToStr_1 = require("tsafe/symToStr");
function createI18nApiFactory(params) {
    const { createUseLang } = params;
    /** @see <https://docs.i18nifty.dev> */
    function createI18nApi() {
        return function (params, translations) {
            const { languages, fallbackLanguage } = params;
            const { useLang, evtLang, withLang } = (() => {
                const result = createUseLang({
                    languages,
                    fallbackLanguage,
                });
                const { useLang, evtLang } = result;
                const { withLang } = result;
                return { useLang, evtLang, withLang };
            })();
            function useResolveLocalizedString() {
                const { lang } = useLang();
                const { resolveLocalizedString } = (0, useGuaranteedMemo_1.useGuaranteedMemo)(() => {
                    const { resolveLocalizedString } = (0, LocalizedString_1.createResolveLocalizedString)({
                        "currentLanguage": lang,
                        fallbackLanguage,
                    });
                    return { resolveLocalizedString };
                }, [lang]);
                return { resolveLocalizedString };
            }
            function useTranslation(componentNameAsKey) {
                const { lang } = useLang();
                const componentName = (0, symToStr_1.symToStr)(componentNameAsKey);
                const t = (0, useGuaranteedMemo_1.useGuaranteedMemo)(() => (key, params) => {
                    const getStrOrFn = (lang) => translations[lang][componentName][key];
                    let strOrFn = getStrOrFn(lang);
                    if (strOrFn === undefined) {
                        strOrFn = getStrOrFn(fallbackLanguage);
                    }
                    return params === undefined ? strOrFn : strOrFn(params);
                }, [lang, componentName]);
                return { t };
            }
            function resolveLocalizedString(localizedString) {
                return (0, LocalizedString_1.createResolveLocalizedString)({
                    "currentLanguage": evtLang.state,
                    fallbackLanguage,
                }).resolveLocalizedString(localizedString);
            }
            const i18nApi = {
                useLang,
                useTranslation,
                useResolveLocalizedString,
                resolveLocalizedString,
                evtLang,
            };
            return Object.assign(Object.assign({}, i18nApi), { withLang });
        };
    }
    return { createI18nApi };
}
exports.createI18nApiFactory = createI18nApiFactory;
